<div class="h-full overflow-hidden relative">
  <!-- Main content - shifts when panel opens -->
  <div class="h-full overflow-y-auto transition-[margin-right] duration-300 px-5 py-4"
       [style.margin-right]="sidePanelOpen ? '450px' : '0'">

    <!-- Farm sections -->
    <div *ngFor="let farm of farms; let farmIndex = index; trackBy: trackByFarm" class="mb-5">
      <!-- Farm Header -->
      <div class="flex items-center mb-3">
        <div class="flex items-center gap-3">
          <span class="text-[14px] font-bold text-[var(--primary-dark)]">{{farm.name}}</span>
          <span class="text-[11px] text-[var(--tertiary-text)]">{{farm.numberOfFields}} fields · {{farm.size | number:'1.1-1'}} HA · {{farm.country}}</span>
          <div class="flex items-center" (click)="$event.stopPropagation()">
            <mat-slide-toggle [(ngModel)]="farm.isBulkAllowNotification"
              (change)="onToggleBulkAllowNotifications($event, farmIndex)">
              <span class="text-[11px] font-medium text-[var(--tertiary-text)]">Notifications</span>
            </mat-slide-toggle>
          </div>
        </div>
      </div>

      <!-- Field Cards Grid -->
      <div class="grid gap-3" style="grid-template-columns: repeat(auto-fill, minmax(180px, 220px))">
        <div *ngFor="let field of farm.fields; let fieldIndex = index; let odd = odd; trackBy: trackByField"
          (click)="openFieldPanel(farm, farmIndex, field, fieldIndex)"
          [title]="cultivarSizeInvalid && selectedField?.fieldId !== field.fieldId ? 'Fix the cultivar size before selecting another field' : ''"
          class="border-[1.5px] rounded-lg p-3.5 cursor-pointer transition-all hover:shadow-[0_4px_12px_rgba(0,0,0,0.08)] hover:border-[var(--primary-dark)]"
          [ngClass]="{
            'opacity-40 cursor-not-allowed pointer-events-none': cultivarSizeInvalid && selectedField?.fieldId !== field.fieldId,
            'border-[var(--primary-dark)] shadow-[0_4px_12px_rgba(0,0,0,0.08)]': selectedField?.fieldId === field.fieldId,
            'border-[var(--app-border)]': selectedField?.fieldId !== field.fieldId,
            'bg-[#f3f4f6]': odd,
            'bg-white': !odd
          }">
          <!-- Card Header -->
          <div class="flex items-start justify-between mb-2">
            <span class="text-[13px] font-bold text-[var(--base-text-dark)] truncate flex-1">{{field.fieldName}}</span>
            <span *ngIf="field.isHarvested" class="text-[9px] font-semibold text-[var(--notification-success)] bg-[#e6f9f3] rounded px-1.5 py-0.5 ml-1.5 shrink-0">Harvested</span>
          </div>
          <!-- Card Body -->
          <div class="flex flex-col gap-1 text-[11px] text-[var(--tertiary-text)]">
            <div class="flex justify-between">
              <span>Type:</span>
              <span class="font-medium text-[var(--base-text-alt-dark)]">{{getFieldTypeName((currentInputByField[field.fieldId]?.fieldType ?? currentInputByField[field.fieldId]?.fieldTypeId) || field.fieldType) || '-'}}</span>
            </div>
            <div class="flex justify-between gap-2">
              <span class="shrink-0">Cultivar:</span>
              <span class="font-medium text-[var(--base-text-alt-dark)] truncate">{{currentInputByField[field.fieldId]?.cultivar || field.cultivar || '-'}}</span>
            </div>
            <div class="flex justify-between">
              <span>Size:</span>
              <span class="font-medium text-[var(--base-text-alt-dark)]">{{field.fieldSize | truncDecimals:2}} HA</span>
            </div>
            <div *ngIf="currentInputByField[field.fieldId]?.plantDate || field.plantDate" class="flex justify-between">
              <span>Planted:</span>
              <span class="font-medium text-[var(--base-text-alt-dark)]">{{dayjs(currentInputByField[field.fieldId]?.plantDate || field.plantDate).format('YYYY-MM-DD')}}</span>
            </div>
          </div>
          <!-- Definitions badge -->
          <div *ngIf="getDefinitions(field).length > 1" class="mt-2 pt-2 border-t border-[var(--app-base)]">
            <span class="text-[10px] font-semibold text-[var(--primary-dark)]">{{getDefinitions(field).length}} definitions</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!isCallDone" class="flex items-center justify-center py-20 text-[var(--tertiary-text)] text-[13px]">
      Loading fields...
    </div>
  </div>

  <!-- Side Panel -->
  <div class="fixed right-0 top-[56px] bottom-0 w-[580px] bg-white shadow-[-4px_0_20px_rgba(0,0,0,0.08)] z-[850] transition-transform duration-300 flex flex-col overflow-hidden"
       [class.translate-x-full]="!sidePanelOpen"
       [class.translate-x-0]="sidePanelOpen">
    <!-- Panel Header -->
    <div class="border-t-[3px] border-t-[var(--primary-dark)]">
      <div class="flex items-center gap-2 py-3 px-5 border-b border-[var(--app-base)]">
        <span class="text-[14px] font-bold text-[var(--base-text-dark)]">{{selectedField?.fieldName}}</span>
        <span class="text-[11px] text-[var(--tertiary-text)]">{{selectedField?.fieldSize | truncDecimals:2}} HA</span>
        <div class="flex-1"></div>
        <span class="material-icons cursor-pointer text-[var(--tertiary-text)] text-[20px] rounded-full w-7 h-7 flex items-center justify-center hover:bg-[var(--app-base)]"
              (click)="closeSidePanel()">close</span>
      </div>
    </div>

    <!-- Definition Tabs (if multiple) -->
    <div *ngIf="selectedField && getDefinitions(selectedField).length > 1" class="px-5 pt-3">
      <div class="flex items-center gap-2 mb-2">
        <span class="text-[12px] font-bold text-[var(--primary-dark)]">Crop Definitions</span>
        <span class="material-icons text-[18px] text-[var(--primary-dark)] cursor-pointer hover:opacity-70"
        [class.opacity-40]="cultivarSizeInvalid" [class.pointer-events-none]="cultivarSizeInvalid"
        [title]="cultivarSizeInvalid ? 'Fix the cultivar size before adding a definition' : 'Add Definition'"
        (click)="addDefinition(selectedField)">add_circle</span>
      </div>
      <mat-tab-group [selectedIndex]="getSelectedDefinitionIndex(selectedField)" (selectedIndexChange)="onDefinitionTabChange(selectedField, $event)">
        <mat-tab *ngFor="let def of getDefinitions(selectedField); let i = index"
          [disabled]="cultivarSizeInvalid && i !== getSelectedDefinitionIndex(selectedField)">
          <ng-template mat-tab-label>
            <div class="def-tab-label flex items-center justify-between w-full min-w-[140px]">
              <span class="text-[11px]">{{ getDefinitionLabel(def, i) }}</span>
              <div *ngIf="getDefinitions(selectedField).length > 1" class="flex items-center justify-end pl-3">
                <span class="def-tab-close material-icons text-[11px] text-[var(--notification-error)] cursor-pointer opacity-0 transition-opacity"
                  (click)="deleteDefinition(selectedField, def, $event)">close</span>
              </div>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>

    <!-- Single definition: add button -->
    <div *ngIf="selectedField && getDefinitions(selectedField).length === 1" class="flex items-center gap-2 px-5 pt-3">
      <span class="text-[12px] font-bold text-[var(--primary-dark)]">Crop Definitions</span>
      <span class="material-icons text-[18px] text-[var(--primary-dark)] cursor-pointer hover:opacity-70"
        [class.opacity-40]="cultivarSizeInvalid" [class.pointer-events-none]="cultivarSizeInvalid"
        [title]="cultivarSizeInvalid ? 'Fix the cultivar size before adding a definition' : 'Add Definition'"
        (click)="addDefinition(selectedField)">add_circle</span>
    </div>

    <!-- Panel Content Tabs: Field Data / Crop Detail / Cost -->
    <div *ngIf="selectedField" class="flex gap-0 px-5 border-b border-[var(--app-base)] mt-3">
      <button (click)="panelTab = 'field'" class="py-2 px-3 text-[11px] font-semibold border-b-2 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        [disabled]="cultivarSizeInvalid && panelTab !== 'field'"
        [title]="cultivarSizeInvalid && panelTab !== 'field' ? 'Fix the cultivar size first' : ''"
        [ngClass]="panelTab === 'field' ? 'text-[var(--primary-dark)] border-[var(--primary-dark)]' : 'text-[var(--tertiary-text)] border-transparent'">Field Data</button>
      <button (click)="panelTab = 'crop'" class="py-2 px-3 text-[11px] font-semibold border-b-2 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        [disabled]="cultivarSizeInvalid && panelTab !== 'crop'"
        [title]="cultivarSizeInvalid && panelTab !== 'crop' ? 'Fix the cultivar size first' : ''"
        [ngClass]="panelTab === 'crop' ? 'text-[var(--primary-dark)] border-[var(--primary-dark)]' : 'text-[var(--tertiary-text)] border-transparent'">Crop Detail</button>
      <button (click)="panelTab = 'cost'" class="py-2 px-3 text-[11px] font-semibold border-b-2 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        [disabled]="cultivarSizeInvalid && panelTab !== 'cost'"
        [title]="cultivarSizeInvalid && panelTab !== 'cost' ? 'Fix the cultivar size first' : ''"
        [ngClass]="panelTab === 'cost' ? 'text-[var(--primary-dark)] border-[var(--primary-dark)]' : 'text-[var(--tertiary-text)] border-transparent'">Cost</button>
    </div>

    <!-- Panel Body -->
    <div class="flex-1 overflow-y-auto px-5 py-4">
      <app-season-field-input *ngIf="selectedField && isCallDone && currentInputByField[selectedField.fieldId]"
        [isViewedFromSeasonAdmin]="true"
        [sharedExtraDetailData]="seasonFormExtraData[selectedField.fieldId]"
        [farmIndex]="selectedFarmIndex"
        [index]="getFieldIndex(selectedFieldIndex, selectedFarmIndex)"
        [inputData]="currentInputByField[selectedField.fieldId]"
        [siblingDefinitions]="getDefinitions(selectedField)"
        [serverCultivarSizeError]="cultivarSizeServerError"
        [panelTab]="panelTab"
        (formDataChange)="onFormDataChange(selectedFieldIndex, selectedFarmIndex, $event)">
      </app-season-field-input>
    </div>
  </div>
</div>
